import { render, staticRenderFns } from "./QuestionsCreate.vue?vue&type=template&id=b3e6e140&"
import script from "./QuestionsCreate.js?vue&type=script&lang=js&"
export * from "./QuestionsCreate.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports